var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.sortedValues),function(value,key){return _c('el-tag',{key:key,attrs:{"size":"mini"}},[_vm._v(_vm._s(_vm.extraKeyFormatter(key) + ':' + value))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }